import { type PropertyLocationRow } from "@/types/propertyLocationRow";

/** 入力欄の初期値に使う、3項目とも空の地番・家屋番号の行を作る。 */
export const createEmptyPropertyRow = (): PropertyLocationRow => ({
  prefName: "",
  location: "",
  chibanAndKaokuNumber: "",
});

// API 由来の行では項目が欠けることがあるため、null・undefined も空として扱う
const isFilled = (value: string | null | undefined): boolean =>
  (value ?? "").trim() !== "";

/**
 * 都道府県・所在・地番（家屋番号）の3項目がすべて入力済みの行か。
 * 役所資料取得依頼と不動産調査依頼で、送信対象の行の判定に共用する。
 */
export const isCompletePropertyRow = (row: PropertyLocationRow): boolean =>
  isFilled(row.prefName) &&
  isFilled(row.location) &&
  isFilled(row.chibanAndKaokuNumber);

/** 3項目がすべて入力済みの行だけを返す（途中まで入力した行は送らない）。 */
export const getCompletePropertyRows = (
  rows: PropertyLocationRow[]
): PropertyLocationRow[] => rows.filter(isCompletePropertyRow);
